export const gitCommit = '23e5eed8'
